import { jsx as b } from "react/jsx-runtime";
import { createContext as h, useState as v, useEffect as S, useCallback as I, useMemo as L } from "react";
import { idsLogger as T } from "../../utils/helpers.js";
import { LoggerLevels as y } from "../../utils/enums.js";
const g = h(void 0), M = ({
  children: m,
  onChange: i,
  defaultSelected: d,
  selected: n
}) => {
  const [l, a] = v([]), [p, u] = v(d), c = n ?? p, t = l.find(
    (e, o) => e.value === c || o === c
  );
  S(() => {
    n !== void 0 && d !== void 0 && T(
      "IressTabSet: Please use either the defaultSelected prop for uncontrolled components, or the selected prop for controlled components, rather than both. If you use both, the selected tab may become unpredictable.",
      y.Warn
    );
  }, [n, d]);
  const f = I((e) => {
    a((o) => {
      if (o.some(
        (s) => s.id === e.id || s.value === e.value
      ))
        return o;
      const r = o.length;
      return u((s) => s !== void 0 ? s : e.value ?? r), [...o, { ...e, index: r, value: e.value ?? r }];
    });
  }, []), x = L(
    () => ({
      items: l,
      active: t,
      register: f,
      indexOf: (e, o) => l.findIndex((r) => r.id === e || r.value === o),
      isActive: (e, o) => (t == null ? void 0 : t.id) === e || (t == null ? void 0 : t.value) === o,
      activate(e, o) {
        i == null || i({ index: e, value: o }), u(o ?? e);
      }
    }),
    [l, t, f, i]
  );
  return /* @__PURE__ */ b(g.Provider, { value: x, children: m });
};
export {
  M as IressTabSetProvider,
  g as TabSetItemsContext
};
